/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_RowsInputs */

const en_tl_rows = /** @type {(inputs: Tl_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows`)
};

const de_tl_rows = /** @type {(inputs: Tl_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilen`)
};

/**
* | output |
* | --- |
* | "Rows" |
*
* @param {Tl_RowsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_rows = /** @type {((inputs?: Tl_RowsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_RowsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_rows(inputs)
	return en_tl_rows(inputs)
});